import Vue from "vue";
import ElementUI from "element-ui";
import App from "./App";
import store from "./store";
import router from "./router";
import request from "./api";
import "@/custom-component"; // 注册自定义组件
import "@/assets/iconfont.css";
import "@/styles/animate.scss";
import "element-ui/lib/theme-chalk/index.css";
import "@/styles/reset.css";
import "@/styles/attr-action.scss";
import "@/styles/list-table.scss";
import "@/styles/app-shell.scss";
import { listSortable, listOverflow, listColWidth, listColMinWidth, listColClass, listColFixed, listColProp } from "@/utils/listTable";

import { startAppVersionWatcher } from "@/utils/appVersion";

import { initI18n, i18nState, LOCALE_EN, wrapElementMessages, patchElementFormI18n } from "@/i18n";
import elementZh from "element-ui/lib/locale/lang/zh-CN";
import elementEn from "element-ui/lib/locale/lang/en";

initI18n(Vue);

function getWidth() {
  var c = document.documentElement.getBoundingClientRect().width * (100 / 750) ;
  document.documentElement.style.fontSize = c + "px";
}
getWidth();
window.onresize = function () { getWidth() };

Vue.use(ElementUI, {
  size: "small",
  locale: i18nState.locale === LOCALE_EN ? elementEn : elementZh,
});
wrapElementMessages(Vue);
patchElementFormI18n();
Vue.config.productionTip = false;
Vue.prototype.$request = request;
Vue.prototype.$listSortable = listSortable;
Vue.prototype.$listOverflow = listOverflow;
Vue.prototype.$listColWidth = listColWidth;
Vue.prototype.$listColMinWidth = listColMinWidth;
Vue.prototype.$listColClass = listColClass;
Vue.prototype.$listColFixed = listColFixed;
Vue.prototype.$listColProp = listColProp;

Vue.prototype.$changeLoadingState = function (status) {
  this.$store.dispatch('changeLoadingState', status);
};

new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
});

startAppVersionWatcher(router);
